import axios from "axios";
import type {
  ConfirmRefillSelectionRequestProto,
  ConfirmRefillSelectionResponseProto,
} from "@noom/noom-contracts/noom_contracts/healthcare/service/healthcare/prescription_refill_service";

import { HEALTHCARE_API } from "@modules/common/constants";

export const confirmRefillSelection = async (
  request: ConfirmRefillSelectionRequestProto,
  accessToken: string
): Promise<ConfirmRefillSelectionResponseProto> => {
  const { accessCode, scheduledFillId, body } = request;
  return (
    await axios.post<ConfirmRefillSelectionResponseProto>(
      `${HEALTHCARE_API}/v1/patient/${accessCode}/scheduled_prescription_fills/${scheduledFillId}/confirm_selection`,
      body ?? {},
      {
        headers: {
          Authorization: `bearer ${accessToken}`,
        },
      }
    )
  ).data;
};
